import React from 'react';
import * as R from 'ramda';
import {Alert} from 'reactstrap';
import {maybe} from '@/util';

const Error = ({error}) => {
  const errorMsg = R.pathOr('', ['response', 'data', 'error'], error);

  return (
    <Alert color='danger'>
      <p>Oops~~Something wrong! Please contact with IT</p>
      {maybe(errorMsg).map(val => (
        <strong>Error message: {val}</strong>
      ))}
    </Alert>
  );
};

export default Error;
